import React from 'react'
import StudentUserSignUp from '../feature/Login/StudentUserSignUp'
import StudentRegisterForm from '../feature/Login/skillvationLogins/StudentRegisterForm'

const StudentUserSignUpPage = () => {
    return (
        <StudentRegisterForm
            signupRoute="collab-register"
            loginRoute="/login"
            bottomLine={<div />} // Add any bottom content like social login
        />
    )
}

export default StudentUserSignUpPage
